import { jsx as _jsx } from "nativewind/jsx-runtime";
import React, { forwardRef } from 'react';
import { View, } from 'react-native';
import { match, Pattern } from 'ts-pattern';
import SignupBoxInput from '@/screens/SignupScreen/components/SignupBoxInput';
const UserNicknameForm = forwardRef(({ value, state, onChangeText, onBlur, onSubmitEditing, isClearable = false }, ref) => {
    return (_jsx(View, { style: { paddingHorizontal: 20 }, children: _jsx(SignupBoxInput, { ref: ref, label: "\uB2C9\uB124\uC784", isRequired: true, placeholder: "\uB2C9\uB124\uC784\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694", returnKeyType: "next", state: state, caption: match(state)
                .with(undefined, () => '닉네임은 영어, 한글, 숫자만 사용 가능해요.')
                .with('VALID', () => '사용 가능한 닉네임입니다.')
                .with('PROGRESS', () => '닉네임 확인 중...')
                .with({ errorMessage: Pattern.string }, error => error.errorMessage)
                .exhaustive(), value: value, onChangeText: onChangeText, onBlur: onBlur
                ? (_e) => onBlur()
                : undefined, onSubmitEditing: onSubmitEditing, isClearable: isClearable }) }));
});
UserNicknameForm.displayName = 'UserNicknameForm';
export default UserNicknameForm;
